import { Dialog } from 'primereact/dialog';
import classes from './futureAddedPopUp.module.scss';
import { Button } from 'primereact/button';
import { Player } from '@lottiefiles/react-lottie-player';
import successAnimation from 'assets/lottieFiles/successAnimation.json';

const FutureAddedPopUp = ({
  visibility,
  toggleVisibility,
  addedFutureTmsData,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  addedFutureTmsData: { COT: string; value: string; startDate: string; endDate: string };
}) => {
  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={'New TMS Added values'}
      visible={visibility}
      style={{ width: '40vw' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      <div className={classes.newFutureTmsContainer}>
        <Player autoplay keepLastFrame className={classes.lottiePlayer} src={successAnimation} />
        <table>
          <thead>
            <tr>
              <th>COT</th>
              <th>Value</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{addedFutureTmsData.COT}</th>
              <th>{addedFutureTmsData.value}</th>
              <th>{addedFutureTmsData.startDate}</th>
              <th>{addedFutureTmsData.endDate}</th>
            </tr>
          </tbody>
        </table>
        <div className={classes.closeButtonDivWrapper}>
          <Button className={classes.closeButton} onClick={toggleVisibility}>
            Close
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default FutureAddedPopUp;
